<div>
  <input autocomplete="off"
         (keyup)="searchStreet(streetInput)"
         type="text"
         #streetInput="ngModel"
         name="details"
         [(ngModel)]="details"
         [disabled]="disabled"
         class="uk-input"
         required
         #streetField
         (change)="onAddressDetailsChangedEvent.emit(details)"
         id="searchLocalityStreetInput"
  >

  <div style="position: absolute; max-height: 200px;" class="uk-overflow-auto">
    <ul class="uk-list uk-list-divider uk-position-relative uk-margin-remove-top"
        style="background-color: white; width: 100%;"
        *ngIf="streets.length > 0"
        [style.width]="streetField.clientWidth + 'px'"
        id="searchLocalityStreetOptionList"
    >
      <li *ngFor="let street of streets"
          (click)="setStreet(street); streetField.focus()"
          style="padding-left: 10px"
          id="searchLocalityStreetOptionListElement"
      >
        {{street.type}} {{street.name}}
      </li>
    </ul>
  </div>
</div>
